import { useQuery } from '@tanstack/react-query';

import type { MonitoringFilters, MonitoringResponse } from '~/types/monitoring';

// Mock data function - substituir com chamada real à API
const fetchMonitoringData = async (): Promise<MonitoringResponse> => {
  // Simulação de chamada à API
  await new Promise(resolve => {
    setTimeout(resolve, 1000);
  });

  // Dados mockados
  return {
    queueStatus: {
      impressions: 587420,
      clicks: 12485,
      impressionsStatus: 'CRITICO', // Simulando estado crítico
      clicksStatus: 'NORMAL', // Estado normal
    },
    chartData: {
      labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'],
      impressions: [450000, 520000, 480000, 587420, 550000, 600000],
      clicks: [9500, 11200, 10800, 12485, 11900, 13200],
    },
  };
};

export const useGetMonitoringData = (filters: MonitoringFilters) => {
  return useQuery({
    queryKey: ['monitoring', filters],
    queryFn: () => fetchMonitoringData(),
    staleTime: 1000 * 60,
  });
};
